export const initialInvestmentModalState = {
  product: '',
  fromWallet: '',
  toWallet: '',
  sentAmount: '',
  sentCurrency: '',
  sentCommission: '',
  sentCommissionCurrency: '',
  sentExchangeRate: '',
  receivedAmount: '',
  receivedCurrency: '',
  receivedCommission: '',
  receivedCommissionCurrency: '',
  receivedExchangeRate: '',
  dateTime: '',
  comment: '',
  walletId: '',
  operationType: '',
  id: '',
}
